module.exports = __webpack_public_path__ + "static/media/2.5de35b24.jpg";